import TextInput from "components/form/input/TextInput";
import { GenericParamFields, ParamFormRow } from "entity/Indicador/components/ParamFields";
import EnlDesp from "..";

export function EnlDespParamFields({ tipoIndicadorField }) {
    return (
        <GenericParamFields
            name={EnlDesp.field + tipoIndicadorField}
            bottomFields={
                <>
                    <ParamFormRow label="Meta">
                        <TextInput name="mecanizado.meta" label="Meta (%)" type="number" />
                    </ParamFormRow>
                </>
            }
        />
    );
}
